import React, { Component } from 'react';
import _ from 'lodash';
import {Container,Col,Form,FormGroup,Button} from 'reactstrap';
import '../../css/components/ToDo/todo.css';

class ToDoCreate extends Component  {



  handleCreate(event) {
    event.preventDefault();

    const createInput = this.refs.createInput;
    const task = createInput.value;
    const validateInput = this.validateInput(task);

    if (validateInput) {
      this.setState({ error: validateInput });
      return false;
    }

    this.setState({ error: null });
    this.props.createTask(task);
    this.refs.createInput.value = '';
  }

  //validate input
  validateInput(task) {
    if (!task) {
      return 'Please enter a task!';
    } else if (_.find(this.props.todos, todo => todo.task === task)) {
      return 'Task already exist!';
    } else {
      return null;
    }
  }


  componentDidMount() {
    this.refs.createInput.focus();
  }

  constructor(props) {
    super(props);

    this.state = {
      error: null
    };
  }

  renderError() {
    if (!this.state.error) { return null; }
    return <div className="alert alert-danger fade show "><i className="fa fa-exclamation-triangle fa-lg mr-2"></i>{this.state.error}</div>;
}

render() {
  return (
      <Form className="create form-horizontal" onSubmit={this.handleCreate.bind(this) }>

      <FormGroup className="d-flex justify-content-center">
          <Col lg="12" xs="12"  >
          <input className="form-control to-do-form" type="text" ref="createInput" placeholder="What needs to be done?" />
          </Col>

        <Col lg="2" xs="2" className="d-flex justify-content-center align-items-center btn-add">
          <Button type="submit" color="none" className="icon-plus icons add-icon"></Button>
          </Col>
             
      </FormGroup> 
{ this.renderError() }
</Form>
        )
}
}

export default ToDoCreate;
